// import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Header from '../components/common/Header';

const mapStateToProps = (state: any) => {
  return {
    header: state.header,
    request_param: state.request_param,
    moffAPI: state.moffAPI,
    moffCheck: state.moffCheck,
  };
};

export default withRouter(connect(
  mapStateToProps
)(Header as any) as any);



// WEBPACK FOOTER //
// ./src/containers/Header.tsx